<div class="gutter">

	<header #header class="flx-col flx-gap-default">
		<h1 #headerTitle *ngIf="pageTitle">{{ pageTitle }}</h1>
		<div *ngIf="pageContent">
			<app-ve [content]="pageContent"></app-ve>
		</div>
	</header>

	<div class="gutter-v-half flx-row flx-wrap-grid flx-wrap-grid-2-xs flx-wrap-grid-3-sm flx-wrap-grid-5-md">
			<div *ngFor="let catalog of catalogs">
				<div class="catalog">
					<a class="catalog-picture-wrap" href="{{ cdn }}/{{ catalog.photos[1].module }}/{{ catalog.photos[1].dir }}/{{ catalog.photos[1].filename }}" target="_blank">
						<app-image [natural]="true" [url]="cdn +'/catalogs/'+ catalog.photos[0].dir + '/medium_' + catalog.photos[0].filename"></app-image>
					</a>
					<a class="catalog-title" href="{{ cdn }}/{{ catalog.photos[1].module }}/{{ catalog.photos[1].dir }}/{{ catalog.photos[1].filename }}" target="_blank">
						{{ catalog.name }}
						<span class="catalog-download"><svg class="icon icon-chevron-down"><use xlink:href="#icon-chevron-down"></use></svg></span>
					</a>
				</div> 
				<div class="catalog-content" *ngIf="catalog.content" [innerHtml]="catalog.content"></div>
			</div>
	</div>
</div>
